import { Button, Input, Tag, Text } from "../../../../components";
import Localization from "../../../../localization";
import React, { useState } from "react";
import { Tools } from "../../../../utils";
import { Flex } from "antd";

const Invite = ({ onConfirm = () => {}, onCancel = () => {} }) => {
  const [emails, setEmails] = useState([]);
  const [text, setText] = useState("");

  const onChange = ({ key, target: { value } }) => {
    if (key === "Enter" || value.includes(" ")) {
      const values = value.split(" ").filter((_) => Tools.isEmail(_));
      if (!values.length) return;
      setEmails((emails) => [...emails, ...values]);
      setText("");
    } else setText(value);
  };

  return (
    <div>
      <Input
        value={text}
        type="textarea"
        onChange={onChange}
        autoSize={{ minRows: 4, maxRows: 6 }}
        onBlur={(_) => onChange({ key: "Enter", ..._ })}
        placeholder={
          Localization.service_edit_collaborators.invite_modal_input_placeholder
        }
        onKeyDown={(e) => {
          onChange(e);
          if (e.key === "Enter") e.preventDefault();
        }}
      />
      <Flex
        gap=".5em"
        wrap="wrap"
        className="m-10-t"
        children={emails.map((email, index) => (
          <Tag
            label={email}
            onClose={() => setEmails(emails.filter((_, i) => i !== index))}
          />
        ))}
      />
      <Flex className="m-30-t" gap={"1rem"}>
        <Button
          type="primary"
          disabled={!emails.length}
          onClick={() => onConfirm(emails)}
          title={Localization.general.confirm}
        />
        <Button
          onClick={() => onCancel()}
          title={Localization.general.cancel}
        />
      </Flex>
    </div>
  );
};

export default Invite;
